import { render } from "./AiAssistant.vue?vue&type=template&id=0219eb0c&scoped=true"
import script from "./AiAssistant.vue?vue&type=script&lang=js"
export * from "./AiAssistant.vue?vue&type=script&lang=js"

import "./AiAssistant.vue?vue&type=style&index=0&id=0219eb0c&scoped=true&lang=css"
import "./AiAssistant.vue?vue&type=style&index=1&id=0219eb0c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0219eb0c"]])

export default __exports__